export default __webpack_public_path__ + "static/media/noImage.1edd6fd3.svg";